import { useCallback, useEffect, useMemo, useState } from 'react';
const STORAGE_KEY = 'sample-site-tasks';
function load() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw)
            return seedTasks();
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : seedTasks();
    }
    catch {
        return seedTasks();
    }
}
function seedTasks() {
    const now = Date.now();
    return [
        { id: crypto.randomUUID(), title: 'Explore the sample UI', done: true, createdAt: now - 86400000 },
        { id: crypto.randomUUID(), title: 'Add your own tasks below', done: false, createdAt: now },
    ];
}
function save(tasks) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(tasks));
}
export function useTasks() {
    const [tasks, setTasks] = useState(() => load());
    const [filter, setFilter] = useState('all');
    useEffect(() => {
        save(tasks);
    }, [tasks]);
    const filtered = useMemo(() => {
        switch (filter) {
            case 'active':
                return tasks.filter((t) => !t.done);
            case 'done':
                return tasks.filter((t) => t.done);
            default:
                return tasks;
        }
    }, [tasks, filter]);
    const stats = useMemo(() => {
        const total = tasks.length;
        const done = tasks.filter((t) => t.done).length;
        const active = total - done;
        const pct = total === 0 ? 0 : Math.round((done / total) * 100);
        return { total, done, active, pct };
    }, [tasks]);
    const addTask = useCallback((title) => {
        const t = title.trim();
        if (!t)
            return;
        setTasks((prev) => [
            { id: crypto.randomUUID(), title: t, done: false, createdAt: Date.now() },
            ...prev,
        ]);
    }, []);
    const toggleTask = useCallback((id) => {
        setTasks((prev) => prev.map((t) => (t.id === id ? { ...t, done: !t.done } : t)));
    }, []);
    const removeTask = useCallback((id) => {
        setTasks((prev) => prev.filter((t) => t.id !== id));
    }, []);
    const clearDone = useCallback(() => {
        setTasks((prev) => prev.filter((t) => !t.done));
    }, []);
    return {
        tasks,
        filtered,
        filter,
        setFilter,
        stats,
        addTask,
        toggleTask,
        removeTask,
        clearDone,
    };
}
